<template>
  <div>
    <FormSearchableSelect
      v-show="!loadingError"
      :options="userLookup"
      :value="value"
      @input="$emit('input', $event)"
      :placeholder="placeholder"
      :field="field"
      :note="note"
      :loading="loading"
    />
    <span class="text-danger" v-if="loadingError">{{loadingError}}</span>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'UserSearchableSelect',
  model: {
    event: 'input'
  },
  props: {
    value: [Number, String],
    placeholder: String,
    field: String,
    note: String,
    allowNone: Boolean
  },
  data() {
    return {
      loading: false,
      loadingError: '',
      userLookup: []
    }
  },
  mounted() {
    this.loading = true

    this.$apiService.userService.getUserList()
    .then(response => {
      this.userLookup = []
      if(this.allowNone)
        this.userLookup = [{ value: null, name: 'None' }]

      this.userLookup = _.concat(this.userLookup, response.data.map(user => {
        return {
          value: user.id,
          name: user.name
        }
      }))
    })
    .catch(err => {
      this.loadingError = 'Error accessing data'
    })
    .finally(() => {
      this.loading = false
    })
  }
}
</script>